import React from 'react';
import { RouterProvider } from 'react-router-dom';

import { ClerkProvider } from '@clerk/clerk-react';
import { Root } from '@nearst/ui';

// @ts-ignore
import { globalCSS } from '@nearst/ui';

import ErrorBoundary from '@components/ErrorBoundary';
import { IntercomIdentity } from '@utils/IntercomIdentity';

import 'tippy.js/dist/tippy.css';
import ClerkTheme from './ClerkTheme.module.scss';

// import must come after ClerkTheme import for style overrides
import { router } from './router.jsx';

export default function App() {
	return (
		<Root className={ClerkTheme.theme}>
			<ErrorBoundary>
				<ClerkProvider publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}>
					<IntercomIdentity product="nearst" />
					<RouterProvider router={router} />
				</ClerkProvider>
			</ErrorBoundary>
		</Root>
	);
}
